<template>
    <div class="cc-einfachbindung">
        <ul>
            <li>sp<sup>3</sup>-Hybridisierung</li>
            <li>σ-Bindung (sigma)</li>
            <li>freie Drehbarkeit</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'cc-einfachbindung',
};
</script>
